import gql from 'graphql-tag';
import {
  CommentsItemsFragment,
  ReviewsItemsFragment
} from '../fragments/fragments.cartEndpoint';

const ReviewsQuery = {
  getReviews: gql`
    query getReviewsAll(
      $setLimit: Int
      $setSource: String
      $setSort: String
      $page: Int
    ) {
      getReviewsAll(
        setLimit: $setLimit
        setSource: $setSource
        setSort: $setSort
        page: $page
      ) {
        totalCount
        reviewsItems {
          ...ReviewsItemsFragment
        }
      }
    }
    ${ReviewsItemsFragment}
  `,
  getAverageReviewsRating: gql`
    query getAverageReviewsRating {
      getAverageReviewsRating
    }
  `,
  getReviewsRating: gql`
    query getReviewsRating {
      getReviewsRating
    }
  `,
  addReview: gql`
    mutation addReview($data: ReviewInput!, $token: String) {
      addReview(data: $data, token: $token) {
        id
      }
    }
  `,
  getReviewTagList: gql`
    query getReviewTagList {
      getReviewTagList {
        id
        title
        type
      }
    }
  `,
  voteForReview: gql`
    mutation voteForReview($data: ReviewVoteInput!, $cartToken: String) {
      voteForReview(data: $data, cartToken: $cartToken) {
        id
        date
        votes_yes
        votes_no
        _voted
      }
    }
  `,
  rateAnswer: gql`
    mutation rateAnswer(
      $storeOrProductCommentType: StoreOrProductCommentsTypeEnum
      $reviewId: Float!
      $rating: Float
      $text: String
    ) {
      rateAnswer(
        storeOrProductCommentType: $storeOrProductCommentType
        reviewId: $reviewId
        rating: $rating
        text: $text
      ) {
        success
        info
        warning
        error
        errorCode
        commentItem {
          id
          text
          answer
          answer_rating_text
          answer_rating
        }
        reviewItem {
          id
          text
          answer
          answer_rating_text
          answer_rating
        }
      }
    }
  `,
  getTopNewestReviews: gql`
    query getTopNewestReviews($setLimit: Int) {
      getTopNewestReviews(setLimit: $setLimit) {
        ...CommentsItemsFragment
      }
    }
    ${CommentsItemsFragment}
  `
};

export default ReviewsQuery;
